import styled from '@material-ui/styles/styled';

import OriginalCountdownTimer from '../../components/CountdownTimer';

export const scannerSharedStyles = {
	position: 'relative',
	top: -50,
	width: '100%',
};

export const CountdownTimer = styled(OriginalCountdownTimer)(({ theme }) => ({
	position: 'absolute',
	zIndex: theme.zIndex.mobileStepper,
	top: theme.spacing(),
	right: theme.spacing(),
}));

export const VideoContainer = styled('div')(({ theme }) => ({
	position: 'relative',
	textAlign: 'center',
	overflow: 'hidden',
}));
